require('./errores.js');
require('./choices.js');
require('./modales.js');
require('./documento.js');
require('./users.js');
require('./clientes.js');
require('./proveedores.js');
require('./facturas.js');
require('./gastos.js');
require('./presupuestos.js');
require('./servicios.js');
require('./home.js');
require('./personal.js');